module.exports = __webpack_public_path__ + "img/head.d72d017b.svg";